import sample_1 from './MoveClean.jpg';

export const moveCleanImpressions = {
    sample_1,
};
